var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9023 9C18.3008 9 12.1016 9.5 8.80078 10.1992C6.60156 10.6992 4.69922 12.1992 4.30078 14.5C3.90234 16.8984 3.5 20.5 3.5 25C3.5 29.5 3.89844 33 4.39844 35.5C4.80078 37.6992 6.69922 39.3008 8.89844 39.8008C12.4023 40.5 18.3984 41 25 41C31.6016 41 37.5977 40.5 41.0977 39.8008C43.3008 39.3008 45.1992 37.8008 45.5977 35.5C46 33 46.5 29.4023 46.5977 24.9023C46.5977 20.4023 46.0977 16.8008 45.5977 14.3008C45.1992 12.1016 43.3008 10.5 41.0977 10C37.5977 9.5 31.5 9 24.9023 9ZM24.9023 11C32.1016 11 37.8984 11.5977 40.6992 12.0977C42.1992 12.5 43.3984 13.5 43.5977 14.8008C44.1992 18 44.5977 21.4023 44.5977 24.9023C44.5 29.1992 44 32.6992 43.5977 35.1992C43.3008 37.0977 41.3008 37.6992 40.6992 37.9023C37.0977 38.6016 31.0977 39.0977 25.0977 39.0977C19.0977 39.0977 13 38.6992 9.5 37.9023C8 37.5 6.80078 36.5 6.60156 35.1992C5.80078 32.3984 5.5 28.6992 5.5 25C5.5 20.3984 5.90234 17 6.30078 14.9023C6.60156 13 8.69922 12.3984 9.19922 12.1992C12.5 11.5 18.6016 11 24.9023 11ZM19.5 17V33L33.5 25L19.5 17ZM21.5 20.4023L29.5 25L21.5 29.5977V20.4023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1f873b6169b42299dc2c63647d4f2b56.svg";
export { ForwardRef as ReactComponent };